//for testing only, to remove once API is integrated
// import { registersList, registerTemplateList } from '@/components/registers/dummyData.js';

const state = {
    organisationRegisters: [],
    registerTemplates: [],
};

const defaultState = () => {
    return {
        organisationRegisters: [],
        registerTemplates: [],
    }
    
};

const mutations = {
    setOrgRegisters(state, registers) {
        state.organisationRegisters = registers;
    },

    resetState(state) {
		Object.assign(state, defaultState());
	},

    
};

const actions = {
    resetState({ commit }) {
      commit("resetState", state)
   },
};

export default {
    name: "register",
    namespaced: true,
    state,
    mutations,
    actions,
};
